import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const Pdd = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
            PDD Partnership
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex max-w-fit'>
              <p className='text-black sm:text-justify md:text-xl'>
              Link and Learn is a certified service provider and in partnership with the Alberta government for the Person’s with Developmental Disability Program (PDD).  We offer a seamless transition for clients transitioning between FSCD funded services and PDD services.  With options for direct billing or private pay, our holistic PDD services provide the essential daily supports for young adults seeking independent living and include a range of aide services, community support services, adult developmental programs and targeted essential skill developments to help adults with developmental disabilities improve their communication, executive and adaptive functioning skills along side of supporting their families and caregivers.  
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/pdd.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Pdd;
